import type { LucideIcon } from 'lucide-react';

interface PageHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
}

/** Tiêu đề trang: icon vuông bo góc + tên + mô tả. */
export function PageHeader({ icon: Icon, title, subtitle }: PageHeaderProps) {
  return (
    <div className="mb-2 flex items-center gap-3.5">
      <div className="border-accent-border bg-accent-soft flex h-11 w-11 items-center justify-center rounded-[10px] border">
        <Icon size={20} className="text-accent" />
      </div>
      <div>
        <h1 className="text-ink m-0 text-[18px] font-bold">{title}</h1>
        <p className="text-ink-dim m-0 mt-0.5 text-[13px]">{subtitle}</p>
      </div>
    </div>
  );
}
